var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 12L19 12","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M13 6L19 11.9988L13 18","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":1})]);
}

Arrow.defaultProps = {"width":"21","height":"24","viewBox":"0 0 21 24","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
